import { AutoplayManager } from '@/managers/autoplay/AutoplayManager'
import { BackendManager } from '@/managers/backend/BackendManager'
import { ReelsManager } from '@/managers/reels/ReelsManager'
import PopupManager from '@/managers/ui/PopupManager'
import { UIManager } from '@/managers/ui/UIManager'
import { WinningManager } from '@/managers/winning/WinningManager'
import { Model } from '@/model/Model'
import Facade from '@/Facade'

export class MainManager {
    public constructor(model: Model) {
        const backendManager = new BackendManager(model)
        ;(Facade as any).backendManager = backendManager
        new ReelsManager(model)
        new PopupManager(model)
        new WinningManager(model)
        new UIManager(model)
        new AutoplayManager(model)
    }
}
